import { HttpBackend } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigOptions, ConfigService } from '@igo2/core/config';
import { ZzzConfigService } from 'src/app/zzz/core/config/config.service';

@Injectable({
  providedIn: 'root'
})
export class SigtConfigServiceService extends ConfigService {

  constructor(private configService: ZzzConfigService) {
    super();
  }

  load(options: ConfigOptions<{ [key: string]: any; }>): void | Promise<unknown> {
    var segment = this.configService.get().estIntranet || this.configService.get().estPartenaire ? '/sigtapi/config' : '/sigtapi/_/config';
    options.path = this.configService.get().authApiEndPoint + segment;
    options.default.authApiEndPoint = options.path;
    return super.load(options);
  }
}
